import * as am5 from '@amcharts/amcharts5/index';
import * as am5xy from '@amcharts/amcharts5/xy';
import { Nullable } from '../../../../global/types';

export function parseValueToNumber(input: any): number | null {
  // If input is already a number, return it directly
  if (typeof input === 'number') {
    return input;
  }

  // If input is not a string, return null
  if (typeof input !== 'string') {
    return null;
  }

  // Remove leading and trailing special characters
  input = input.replace(/^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g, '').trim();

  if (input === '') {
    return null;
  }

  // Try to parse as integer
  const intValue = parseInt(input, 10);
  if (!isNaN(intValue) && intValue.toString() === input) {
    return intValue;
  }

  // Try to parse as float
  const floatValue = parseFloat(input);
  if (!isNaN(floatValue) && floatValue.toString() === input) {
    return floatValue;
  }

  // If parsing fails, return null
  return null;
}

export const addAxisLabelsToXYChart = (chartRoot: am5.Root, chart: am5xy.XYChart, xLabel: Nullable<string>, yLabel: Nullable<string>):void => {
  if (!!xLabel) {
    chart.xAxes?.getIndex(chart.xAxes.length - 1)?.children?.push?.(
      am5.Label.new(chartRoot, {
        text: xLabel,
        textAlign: 'right',
        x: am5.percent(55),
        fontSize: 14,
      }),
    );
  }

  if (!!yLabel && chart.yAxes?.getIndex(chart.yAxes.length - 1)) {
    chart.yAxes?.getIndex(chart.yAxes.length - 1)?.children?.push?.(
      am5.Label.new(chartRoot, {
        text: yLabel,
        textAlign: 'right',
        x: am5.percent(0),
        y: am5.percent(25),
        fontSize: 14,
        rotation: 270,
        dx: -25
      }),
    );
      chart.set("paddingLeft", 25)
  }
};

export const parseValueToNumberMultiSeries = (yFields: {fieldName: string, fieldLabel: string}[], rowData: {[key: string]: string}) => {
  const yFieldsData = {};

  for(let yField of yFields){
    yFieldsData[yField.fieldName] = parseValueToNumber(rowData?.[yField.fieldName]);
  }

  return yFieldsData;
}